import { CheckCircleOutlined, CloseCircleOutlined, LoadingOutlined, MailOutlined } from '@ant-design/icons'
import { Button, Card, Image, Spin } from 'antd'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { BE_HOST } from '../../config/config'
// import Applogo from "../../LOGOAPP.png"
import newLogo from '../../assets/advant-logoTm.png'
import appLogo from '../../assets/aapaNewlogoTm.png'



const EmailVerification = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");
    const [status, setStatus] = useState("loading");
    const [msg, setMsg] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        const verifyEmail = async () => {
            if (!token) {
                setStatus("error");
                setMsg("Verification token missing.");
                return;
            }

            try {
                const res = await axios.get(`${BE_HOST}/auth/verify-email?token=${token}`);
                setStatus("success");
                setMsg(res.data?.message || "Email verified successfully.");
            } catch (err) {
                console.error("Verification failed:", err);
                setStatus("error");
                setMsg(err?.response?.data?.message || "Invalid or expired token.");
            }
        };

        verifyEmail();
    }, [token]);

    const handleLoginRedirect = () => {
        navigate("/Login");
    };

    return (
        <div className="min-h-screen bg-[#000833] flex flex-col items-center justify-center p-4">
            <div className='mb-2'>
             <Image
                    style={{marginTop:"6px"}}
                      src={appLogo}
                      alt="AAPA Logo"
                      preview={false}
                      className=" rounded-md"
                      width={160}
                      height={140}                      
                    />
                </div>
            <div className="w-full max-w-[800px] flex flex-col items-center bg-[#000833] rounded-2xl border-[3px] border-white">
                {/* Logo */}
                <Image
                    style={{ marginTop: "28px", marginBottom: "28px" }}
                    src={newLogo}
                    alt="AAPA Logo"
                    preview={false}
                    width={300}
                    className="mb-8"
                />

                <Card className="w-full max-w-[400px] shadow-lg rounded-lg overflow-hidden bg-[#000833] text-center">
                    <h2 className="text-2xl font-bold text-white mb-4 flex items-center justify-center gap-2">
                        <MailOutlined style={{ fontSize: 26, color: "#0EA5E9" }} />
                        Email Verification
                    </h2>

                    {status === "loading" && (
                        <Spin
                            indicator={<LoadingOutlined style={{ fontSize: 24, color: "#0EA5E9" }} spin />}
                            tip="Verifying..."
                            size="large"
                        />
                    )}

                    {status === "success" && (
                        <>
                            <CheckCircleOutlined style={{ fontSize: 40, color: "#22c55e", marginBottom: 12 }} />
                            <p className="text-white mb-4">{msg}</p>
                            <Button
                                type="primary"
                                className="h-12 bg-[#0EA5E9] hover:bg-[#0EA5E9]/90"
                                block
                                size="large"
                                onClick={handleLoginRedirect}
                            >
                                Go to Login
                            </Button>
                        </>
                    )}

                    {status === "error" && (
                        <>
                            <CloseCircleOutlined style={{ fontSize: 40, color: "#ef4444", marginBottom: 12 }} />
                            <p className="text-white mb-4">{msg}</p>
                            <Button
                                type="primary"
                                className="h-12 bg-[#0EA5E9] hover:bg-[#0EA5E9]/90"
                                block
                                size="large"
                                onClick={handleLoginRedirect}
                            >
                                Back to Login
                            </Button>
                        </>
                    )}
                </Card>

                {/* Footer */}
                <div className="mt-8 text-center text-white text-sm mb-7">
                    <p>Powered by AdvantEdge Analytics</p>
                    <p className="mt-2">
                        © AdvantEdge Holding LLC. (2025). All Rights Reserved
                    </p>
                </div>
            </div>
        </div>
    );
};

export default EmailVerification;
